import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SettingsCard from '../../../components/Settings/SettingsCard'
import selectionStyles from '../../../components/Settings/SelectionModal.module.scss'

export default function CollaborationAdminsCard({
  admins,
  onAddClick,
  onRemoveAdmin,
  onSave,
  hasChanged,
  isSaving,
}) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="users"
      title={t('event.add_admins_title', 'Collaboration')}
      description={t(
        'business.edit.admins_description',
        'Add up to 5 admins who can help manage this business account.',
      )}
      actions={
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSave}
          disabled={!hasChanged || isSaving}
        >
          {isSaving
            ? t('users.edit.saving', 'Saving...')
            : t('business.edit.save')}
        </button>
      }
    >
      {admins.length > 0 ? (
        <div className={selectionStyles.selectedList}>
          {admins.map(admin => (
            <div key={admin.id} className={selectionStyles.selectedRow}>
              <span className={selectionStyles.selectedName}>
                {admin.name} (@{admin.nickname})
              </span>
              <button
                type="button"
                className={selectionStyles.remove}
                onClick={() => onRemoveAdmin(admin)}
              >
                {t('settings.selection.remove', 'Remove')}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className={selectionStyles.empty}>
          {t('settings.selection.none', 'Nothing selected yet.')}
        </p>
      )}

      <button className="btn btn-primary" type="button" onClick={onAddClick}>
        + {t('event.add_admins')}
      </button>
    </SettingsCard>
  )
}

CollaborationAdminsCard.propTypes = {
  admins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string,
      nickname: PropTypes.string,
    }),
  ),
  onAddClick: PropTypes.func.isRequired,
  onRemoveAdmin: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanged: PropTypes.bool,
  isSaving: PropTypes.bool,
}

CollaborationAdminsCard.defaultProps = {
  admins: [],
  hasChanged: false,
  isSaving: false,
}
